module.exports = __webpack_public_path__ + "static/media/smile_face.7f4ca516.png";